import { useRef } from 'react'
import { useSubscription } from '@apollo/client'
import { AdminAPI, getFragment, GraphQL, SharedAPI } from '@guestgoodie/graphql'
import { useAuth } from '@/features/auth'

export function usePmsSubscription() {
  const { isSignedIn, hasOrg } = useAuth()
  const prevSyncingRef = useRef<GraphQL.SyncableObject[]>([])

  useSubscription(AdminAPI.pms.UPDATED, {
    skip: !isSignedIn || !hasOrg,
    onData({ client, data }) {
      const pms = getFragment(SharedAPI.pms.PMS_FRAGMENT, data.data?.pmsUpdated)

      if (!pms) return

      const prevSync = prevSyncingRef.current ?? []
      const currSync = pms.syncing ?? []

      client.cache.updateQuery({ query: AdminAPI.pms.GET }, () => {
        const syncedData = prevSync.filter(
          syncObject => !currSync.includes(syncObject)
        )

        syncedData?.forEach(syncObject => {
          switch (syncObject) {
            case GraphQL.SyncableObject.Rooms:
              client.cache.evict({ fieldName: 'Space' })
              client.cache.gc()
              client.refetchQueries({ include: [AdminAPI.space.QUERY] })

              return

            case GraphQL.SyncableObject.Stays:
              client.cache.evict({ fieldName: 'Stay' })
              client.cache.evict({ fieldName: 'Guest' })
              client.cache.gc()

              client.refetchQueries({
                include: [AdminAPI.stay.QUERY, AdminAPI.guest.QUERY]
              })

              return
          }
        })

        prevSyncingRef.current = currSync

        return {
          getPms: pms
        }
      })
    }
  })
}
